import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'test-exam',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    grid: {
      minHeight: 'calc(100vh - 200px)',
    },
  }),
  options
);

export default useStyles;
